import { useModals } from '@carboncopyco/editor-ui';
import { useCallback, useMemo } from 'react';

const editorModals = [
  'save',
  'exit',
  'findReplace',
  'changeTracker',
  'customCharts',
  'variable',
  'customCode',
  'transactions',
  'navigation',
  'importManager',
  'spotEditsManager',
  'objectsManager',
  'guidanceManager',
  'aiManager',
  'demoLocked',
  'editorPerformanceManager',
] as const;

export type EditorModalName = (typeof editorModals)[number];

export const useEditorModals = () => {
  const modals = useModals(editorModals);

  const closeOtherModals = useCallback(
    (name: string) =>
      editorModals
        .filter((editorModal) => editorModal !== name)
        .forEach(modals.close),
    [modals.close]
  );

  const open = useCallback(
    (name: EditorModalName) => {
      closeOtherModals(name);
      modals.open(name);
    },
    [closeOtherModals, modals.open]
  );

  const toggle = useCallback(
    (name: EditorModalName) => {
      closeOtherModals(name);
      modals.toggle(name);
    },
    [closeOtherModals, modals.toggle]
  );

  return useMemo(
    () => ({
      ...modals,
      open,
      toggle,
    }),
    [modals, open, toggle]
  );
};
